// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';
import { navigationLogoItemPropType } from '../propTypes';
import styled from '../utils/styled';
import { mediaBreakpointUpSM, mediaBreakpointUpXL } from '../../constants/style-constants';

const ExploreItem = ({ item, onHoverItem }) => {
  const current = navigationItem => (navigationItem.link === window.location.pathname ? 'page' : false);
  const ariaLabel = `${item.title}${item.subTitle ? `, ${item.subTitle}` : ''}`;

  return (
    <ListItem>
      {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */}
      <Link
        role="menuitem"
        href={item.link}
        aria-current={current(item)}
        aria-label={ariaLabel}
        active={item.link === window.location.pathname}
        onMouseOver={() => onHoverItem(item)}
      >
        {item.image && (
        <LogoContainer>
          <Logo
            heightBase={item.heightOverrideBase}
            heightSmUp={item.heightOverrideSmallAndUpBreakpoint}
            src={item.image.file.url}
            alt={item.image.title}
          />
        </LogoContainer>
        )}
        {!item.image && (
        <Title color={item.color}>{item.text}</Title>
        )}
        {item.subTitle && <SubTitle>{item.subTitle}</SubTitle>}
      </Link>
    </ListItem>
  );
};

const ListItem = styled.li({
  /* stylelint-disable selector-type-case, selector-type-no-unknown, string-quotes */
  alignItems: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '0',
  borderBottom: '1px solid #000000',
  display: 'flex',
  flex: '1',
  margin: '0',
  listStyle: 'none',
  opacity: '1',
  padding: '0',

  [mediaBreakpointUpSM]: {
    borderTop: '1px solid #343434',
    borderBottom: 'none',
    flex: '1',
  },
});

const Link = styled.a({
  flex: '1',
  padding: '0 30px',
  transition: 'background-color 0.3s linear',

  '&:hover': {
    backgroundColor: '#383838',
  },

  [mediaBreakpointUpSM]: {
    padding: '0 20px',
  },
});

const LogoContainer = styled.div({
  padding: '20px 0',
});

const Logo = styled.img(({ heightBase = 13, heightSmUp = 20 }) => ({
  display: 'block',
  height: `${heightBase}px`,

  [mediaBreakpointUpSM]: {
    height: `${heightSmUp}px`,
  },
}));

const Title = styled.span(({ color }) => ({
  display: 'block',
  color: color || '#FFFFFF',
  fontSize: '14px',
  fontFamily: "'Spyscapetwo webfont'",
  fontWeight: '300',
  lineHeight: '24px',
  margin: '13px 0',
  textTransform: 'uppercase',

  [mediaBreakpointUpSM]: {
    fontSize: '24px',
    lineHeight: '36px',
    margin: '10px 0',
  },
}));

const SubTitle = styled.span({
  display: 'block',
  color: '#989898',
  fontSize: '10px',
  fontFamily: "'Spyscapetwo webfont'",
  marginTop: '8px',
  textTransform: 'uppercase',
  fontWeight: '300',
  lineHeight: 'normal',

  [mediaBreakpointUpXL]: {
    display: 'none',
  },
});

ExploreItem.propTypes = {
  item: navigationLogoItemPropType,
  onHoverItem: PropType.func,
};

ExploreItem.defaultProps = {
  item: {},
  onHoverItem: () => undefined,
};

export default ExploreItem;
